import React from "react";

/* A self-contained, no-network architectural "image": layered gradients +
   a thin gold horizon line + a subtle structural grid. Distinct per asset. */
export default function AssetVisual({ tone = ["#1a1c22", "#2c2f3a"], accent = "#D4AF37", label, height = "100%" }) {
  const [a, b] = tone;
  return (
    <div style={{ position: "relative", width: "100%", height, overflow: "hidden", background: a }}>
      <svg viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} aria-hidden="true">
        <defs>
          <linearGradient id={`g-${a.replace("#", "")}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={b} />
            <stop offset="100%" stopColor={a} />
          </linearGradient>
        </defs>
        <rect width="600" height="400" fill={`url(#g-${a.replace("#", "")})`} />
        {/* structural columns */}
        {[120, 240, 360, 480].map((x) => (
          <rect key={x} x={x} y="0" width="1" height="400" fill="#ffffff" opacity="0.05" />
        ))}
        {/* horizon */}
        <rect x="0" y="262" width="600" height="1" fill={accent} opacity="0.55" />
        {/* abstract massing blocks */}
        <rect x="60" y="170" width="120" height="92" fill="#ffffff" opacity="0.04" />
        <rect x="210" y="120" width="150" height="142" fill="#ffffff" opacity="0.06" />
        <rect x="390" y="200" width="150" height="62" fill="#ffffff" opacity="0.05" />
        <circle cx="500" cy="80" r="34" fill={accent} opacity="0.12" />
      </svg>
      {label && (
        <span
          style={{
            position: "absolute", left: 16, bottom: 14,
            fontSize: "0.66rem", letterSpacing: "0.2em", textTransform: "uppercase",
            color: "rgba(249,249,251,0.82)", fontWeight: 600,
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
}
